import { Component, EventEmitter, Input, OnInit, Output, NgZone } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, FormGroup } from '@angular/forms';
import { UtilService } from '../../services/util.service';
import { SharedDataService } from '../../services/shared-data.service';
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-multiple-choice-field',
  templateUrl: './multiple-choice-field.component.html',
  styleUrls: ['./multiple-choice-field.component.scss'],
})
export class MultipleChoiceFieldComponent implements OnInit {
  UtilService = UtilService;

  // Tracks which questions have already had their post-relaunch checkbox
  // correction applied (see ngAfterViewInit). Without this, re-showing a
  // question via Show/Hide logic later in the same session recreates this
  // component and would incorrectly re-force its answer from the original
  // relaunch snapshot, even after the user has deliberately cleared it by
  // hiding it. Static so it's shared across every instance of this component
  // for the lifetime of the app session, not just this one question's.
  private static relaunchCorrectedQuestionIds = new Set<any>();

  @Input() inputName: string;
  @Input() form: UntypedFormGroup;
  @Input() list: Array<any>;
  @Input() isShowAnswerScoreEnabled: boolean;
  @Input() questionId: any;
  @Input() preValue: any;

  @Output() answerUpdated = new EventEmitter<any>();

  checkboxStates: { answerChoiceAttributeId: number, isChecked: boolean, questionId: any }[] = [];
  preValueArray= [];

  constructor(public sharedDataService: SharedDataService, private cdr: ChangeDetectorRef, private zone: NgZone) { }

  ngOnInit() {
    // console.log('multi choice prevalue', this.preValue);
    if (this.preValue) {
      this.preValueArray = this.preValue.split(',').map(value => Number(value.trim()));
      this.list.forEach(item => {
        if (!this.preValueArray.includes(item.answerChoiceAttributeId)) {
          this.updateState(null, item.answerChoiceAttributeId);
        }
      });
      this.initializeFormControls();
    }
    // Trigger change detection after initializing form controls
    this.cdr.detectChanges();
  }
  
  ngAfterViewInit() {
    setTimeout(() => {
      //this.initializeFormControls();
      this.cdr.detectChanges();
    }, 500);
    const ionChecks = document.querySelectorAll('ion-checkbox');
  
    let timer;
    if(UtilService.isWebApp()){
      timer=2000
    }else{
      timer=5000
    }

    if ((this.sharedDataService.relaunchInfo?.relaunch || this.sharedDataService.dedicatedmodeRelaunchData?.isRelaunch)
      && !MultipleChoiceFieldComponent.relaunchCorrectedQuestionIds.has(this.questionId)) {
      MultipleChoiceFieldComponent.relaunchCorrectedQuestionIds.add(this.questionId);
      setTimeout(() => {
        this.preValueArray.forEach(item => {
          ionChecks.forEach((box) => {
            const parentAnswerChoiceId = parseInt(box.dataset.parentAnswerChoiceId, 10);
  
            if (parentAnswerChoiceId !== 0) {
              // If this checkbox has a parent answer choice ID
                
              if (`mcs-${parentAnswerChoiceId.toString()}` === `mcs-${item.toString()}`) {
                // Find the parent checkbox that corresponds to the `item`
                const parentBox = Array.from(ionChecks).find((checkbox) => {
                  return checkbox.getAttribute('data-parent-answer-choice-id') === item.toString();
                });
  
                if (parentBox) {
                  console.log("selecting w/parent: ", parentBox.id)
                  parentBox.click();
                  parentBox.setAttribute("aria-checked", "true");
                  parentBox.dispatchEvent(new Event('change'));
                }
              }
            } else {
              // If it's a checkbox without a parent (parentAnswerChoiceId === 0)
              if (box.id === `mcs-${item.toString()}`) {
                console.log("selecting: ", box.id)
                const formControlName = `${item}`;
                const formControl = this.form.get(formControlName);
                if(box.ariaChecked !== "true"){ 
                  box.click();
                  box.dispatchEvent(new Event('change'));
                }
                box.setAttribute("aria-checked", "true");
                if (formControl) {
                  this.zone.run(() => {
                    formControl.setValue(true); // Update form control value
                  });
                }
              }
            }
          });
        });
  
        // Trigger change detection after all updates
        this.cdr.detectChanges();
      }, timer); // Delay to ensure DOM elements are ready
    }
  }
  
  
  createUpdateObject(id, checked = false){
      const updateEvent = new CustomEvent('change',{
      bubbles: true,
      cancelable: true,
      composed: true,
      detail: { checked: checked, value: id },
    })
    return updateEvent
  }
  initializeFormControls() {
    if (this.form && this.list) {
      this.list.forEach(item => {
        console.log('from initializeFormControls');
        const controlName = this.UtilService.SubFCName(this.inputName, item.answerChoiceAttributeId);
        const isChecked = this.preValueArray.includes(item.answerChoiceAttributeId);

        const nestedFormGroup = this.form.get(this.inputName) as UntypedFormGroup;

        if (nestedFormGroup) {
          if (!nestedFormGroup.contains(controlName)) {
            nestedFormGroup.addControl(controlName, new UntypedFormControl(isChecked));
          } else {
            const control = nestedFormGroup.get(controlName);
            if (control) {
              control.setValue(isChecked);
            } else {
              console.error(`Control not found: ${controlName}`);
            }
          }
        } else {
          console.error(`Nested form group not found: ${this.inputName}`);
        }
      });
    } else {
      console.error('Form or list is null or undefined.');
    }
  }
  

    lastTouchX= 0
    lastTouchY = 0
    MOVE_THRESHOLD = 10;
    storeTouchStart(event){
      const touch = event.touches[0];
        this.lastTouchX = touch.clientX;
        this.lastTouchY = touch.clientY;
    }

    IdsThatShouldNotEmit = ["AccidentReportAboutSection"] //Note: specifically for elements in fixed sections that do not need to emit and could cause issues if they did
    checkShouldEmit(event){
      try{
      const target = event.target as Element
      for (const entry of this.IdsThatShouldNotEmit){
        try{
          if(target.parentElement.parentElement.id == entry){
            return false
          }
        } catch{}
      }
      return true
    }catch{return true}
    }

    onLabelClick(item: any) {
      const controlName = UtilService.SubFCName(this.inputName, item.answerChoiceAttributeId);
      const nestedGroup = this.form.get(this.inputName) as UntypedFormGroup;
      const control = nestedGroup?.get(controlName);
      if (!control) return;

      const newValue = !control.value;
      control.setValue(newValue);

      const index = this.checkboxStates.findIndex(
        (cb) => cb.answerChoiceAttributeId === item.answerChoiceAttributeId
      );
      if (index !== -1) {
        this.checkboxStates[index].isChecked = newValue;
      } else {
        this.checkboxStates.push({ answerChoiceAttributeId: item.answerChoiceAttributeId, isChecked: newValue, questionId: this.questionId });
      }
      this.sharedDataService.checkboxStates = this.checkboxStates;
      this.answerUpdated.emit({ answerChoiceAttributeId: item.answerChoiceAttributeId, isChecked: newValue, questionId: this.questionId });
    }

    onCheckboxClick($event){
      if(this.sharedDataService.isMobile){
        if (event instanceof TouchEvent) {
          const touch = event.changedTouches[0];
          const endX = touch.clientX;
          const endY = touch.clientY;

          // Calculate the distance moved during the touch and dont click the button if it was a swipe
          const distanceX = Math.abs(endX - this.lastTouchX);
          const distanceY = Math.abs(endY - this.lastTouchY);
          if (distanceX > this.MOVE_THRESHOLD || distanceY > this.MOVE_THRESHOLD) {
            event.preventDefault();
          } else {
            const section = document.querySelector('section.summary-display');
            
          if (section) {
            const checkbox = event.target as HTMLInputElement;
            checkbox.checked = !checkbox.checked;
            if(this.checkShouldEmit(event)){
              checkbox.dispatchEvent(new Event('change')); 
            } else{
              event.preventDefault()
            }
          }
        }
        }
      }
    } 

	updateState(event: CustomEvent =null, answerChoiceAttributeId: any=null) {
    if(!this.checkShouldEmit(event)){
      event.preventDefault()
      return
    }

    if (event && event.detail !== undefined) {
      let isChecked = event.detail.checked;

      const index = this.checkboxStates.findIndex(
        (checkbox) => checkbox.answerChoiceAttributeId === answerChoiceAttributeId
      );

      if (index !== -1) {
        this.checkboxStates[index].isChecked = isChecked;
      } else {
        this.checkboxStates.push({
          answerChoiceAttributeId: answerChoiceAttributeId,
          isChecked: isChecked,
          questionId: this.questionId
        });
      }

      const checkboxInfo = {
        answerChoiceAttributeId: answerChoiceAttributeId,
        isChecked: isChecked,
        questionId: this.questionId
      };

      this.sharedDataService.checkboxStates = this.checkboxStates;
      this.answerUpdated.emit(checkboxInfo);
    } else {
      console.error('Event object or its properties are undefined:', event, answerChoiceAttributeId);
    }
  }
}
